<template>
  <v-page-content>
    <b-card class="classes-card" responsive>
      <b-row class="mb-3">
        <b-col sm="12" md="7">
          <h4>
            <em class="fas fa-school"></em> <span class="ml-2"> Газпром-классы </span>
          </h4>
        </b-col>
      </b-row>
      <div class="ag-grid-vue-classes-list mt-2" ref="gridDiv">
        <ag-grid-vue
          class="ag-theme-material classes"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
          @rowSelected="onRowSelected"
          @filterChanged="onFilterChanged"
        >
        </ag-grid-vue>
      </div>
      <b-row class="sm pagination-row">
        <div class="ml-auto sm p-3 addButtons">
          <b-btn variant="primary"
                 class="addButton mr-1"
                 @click="onAddClicked"
          >
            <em class="fas fa-plus send-icon mr-1"></em>Добавить новый класс
          </b-btn>
          <b-btn variant="primary"
                 class="addButton mr-1"
                 @click="removeClassFromResource"
                 v-b-modal.classesRemoveModal
                 :disabled="storageLength < 1"
          >
            <span v-if="storageLength < 1"
                  v-b-tooltip.mouseover
                  title="Выберите один или несколько классов"
            >
              <em class="fas fa-times-circle"></em> Удалить
            </span>
            <span v-else>
              <em class="fas fa-times-circle"></em> Удалить
            </span>
          </b-btn>
        </div>
      </b-row>
    </b-card>
    <class-operations-modal
      :is-add-modal="isAddFunction"
      :chosen-class="selectedClass"
      :classes-olympiad-id="olympiadId"
      @classOperationCompleted="forceFetch"
    />
    <classes-remove-modal
      :chosen-classes="removableClasses"
      @classesRemoved="forceFetch"/>
  </v-page-content>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'

import _ from 'lodash'
import organizationApi from '@/api/organization'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import { clientWidthType } from '@/config/config'
import OrganizationActionsRenderer from '@/components/admin/actions/OrganizationActionsRenderer'
import PartialMatchFilter from '@/components/helpers/filters/PartialMatchFilter'

const ClassesRemoveModal = () => import('@/components/admin/modals/classes/ClassesRemoveModal.vue')
const ClassOperationsModal = () => import('@/components/admin/modals/classes/ClassOperationsModal.vue')

export default {
  name: 'Classes',
  components: {
    'ag-grid-vue': AgGridVue,
    ClassOperationsModal,
    ClassesRemoveModal
  },
  data() {
    return {
      /* Все, что касается таблицы */
      gridOptions: {
        defaultColDef: {
          headerName: '',
          autoHeight: false,
          sortable: true,
          filter: 'PartialMatchFilter',
          headerClass: 'classes-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        suppressRowClickSelection: true,
        localeText: AG_GRID_LOCALE_RU,
        pagination: true,
        paginationPageSize: 20,
        rowHeight: 90,
        rowSelection: 'multiple',
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true,
        frameworkComponents: {
          OrganizationActionsRenderer,
          PartialMatchFilter
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: 'Название',
          field: 'title',
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          cellStyle: null,
          width: 350
        },
        {
          headerName: 'Город',
          field: 'city'
        },
        {
          headerName: 'Адрес',
          field: 'address',
          width: 300
        },
        {
          headerName: 'Организация',
          field: 'org',
          width: 300,
          cellStyle: {
            'white-space': 'normal'
          }
        },
        {
          headerName: 'Год',
          field: 'year',
          width: 80,
          filter: null
        },
        {
          headerName: 'Сайт',
          field: 'siteUrl'
        },
        {
          field: 'edit',
          width: 54,
          cellRenderer: 'OrganizationActionsRenderer',
          filter: null
        }
      ],
      rowData: null,
      /* Остальное */
      storageLength: 0,
      selectedClasses: [],
      selectedClass: null,
      removableClasses: [],
      olympiadId: [],
      isAddFunction: true
    }
  },
  created() {
    sessionStorage.clear()
    this.storageLength = 0
    organizationApi.getClasses().then(({ data }) => {
      this.rowData = data
      this.olympiadId = data.map((cl) => cl.alienSystemDictId)
      this.gridOptions.api.setRowData(this.rowData)
    })
    this.debouncedFetchFilteredData = _.debounce((filters, sorting) => {
      this.debouncedFetch(filters, sorting)
    }, 500)
  },
  beforeDestroy() {
    sessionStorage.clear()
  },
  methods: {
    onFilterChanged() {
      this.debouncedFetchFilteredData(this.gridOptions.api.getFilterModel())
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.COMMON) {
        this.gridApi.sizeColumnsToFit()
      }
      params.api.resetRowHeights()
    },
    onGridSizeChanged() {
      if (this.$refs.gridDiv.clientWidth >= clientWidthType.WIDE) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    onRowSelected(params) {
      sessionStorage.setItem(params.node.data.id, params.node.selected)
      const keys = Object.keys(sessionStorage)
      this.storageLength = keys.filter((el) => (sessionStorage.getItem(el) === 'true')).length
    },
    onParentEditClicked(data) {
      this.isAddFunction = false
      this.selectedClass = data
      this.$bvModal.show('classOperationsModal')
    },
    onAddClicked() {
      this.gridOptions.api.deselectAll()
      this.isAddFunction = true
      this.selectedClass = null
      this.$bvModal.show('classOperationsModal')
    },
    async forceFetch() {
      sessionStorage.clear()
      this.storageLength = 0
      organizationApi.getClasses().then(({ data }) => {
        this.rowData = data
        this.gridOptions.api.setRowData(this.rowData)
      })
    },
    debouncedFetch(filters) {
      organizationApi.getFilteredOrganizations({
        filters: filters || ' ',
        type: 'classes'
      })
        .then(({ data }) => {
          this.rowData = data
          this.gridOptions.api.setRowData(this.rowData)
        })
    },
    removeClassFromResource() {
      const keys = Object.keys(sessionStorage)
      this.selectedClasses = keys.filter((el) => (sessionStorage.getItem(el) === 'true'))
      this.removableClasses = this.rowData.filter(
        (cl) => this.selectedClasses.includes(String(cl.id)),
      )
        .map((classForRemove) => ({
          id: classForRemove.id,
          title: classForRemove.title,
          city: classForRemove.city,
          address: classForRemove.address,
          siteUrl: classForRemove.siteUrl,
          year: classForRemove.year
        }))
      this.$bvModal.show('classesRemoveModal')
    }
  }
}
</script>

<style lang="scss">
  @import "../../sass/vendor/bootstrap/variables";

  .classes {
    width: 100%;
    height: 100%;
  }

  .ag-grid-vue-classes-list {
    height: calc(100vh - 280px);
    border-bottom: 1px solid lightgray;
  }

  .classes-card .ag-grid-vue-classes-list .ag-cell {
    display: flex;
    align-items: center;
    font-size: 15px;
    justify-content: left;
    text-align: left;
    white-space: normal;
    line-height: 1.4em;
  }

  .classes-card .classes-table-header {
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: left;
    color: #000;
    font-weight: bold;
  }

  .classes-card .ag-cell {
    padding-left: 24px !important;
  }

  .organizations-actions-renderer {
    cursor: pointer;
  }
</style>
